module.exports = __webpack_public_path__ + "img/addIndividual.cbe28f3d.svg";